var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'has-error': !!_vm.error }},[_vm._t("default"),(_vm.error)?_c('span',{staticClass:"error-hint"},[_vm._v(_vm._s(_vm.error))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }